import { hideLoader, showLoader } from "../Store/Readux/Reducer/LoaderSlice";
import {
  setWebMenuData,
  setViewWebMenuData,
} from "../Store/Readux/Reducer/WebMenuSlice";
import ApiConstants from "../Utils/ApiConstant";
import fetchServices from "./FetchServices";

export const getWebMenuData = (token) => async (dispatch, getState) => {
  dispatch(showLoader());
  try {
    const URL = ApiConstants.WebMenuURL;
    const method = "GET";
    const response = await fetchServices(URL, method, {});
    if (response.status_code === 200) {
      dispatch(setWebMenuData(response.data));
    }
    console.log("Web menu data response:", response);
    return response;
  } catch (error) {
    console.log(error.message);
  } finally {
    dispatch(hideLoader());
  }
};

export const addWebMenu = (requestBody) => async (dispatch, getState) => {
  dispatch(showLoader());
  try {
    let URL = ApiConstants.WebMenuURL;
    const method = "POST";
    const response = await fetchServices(
      URL,
      method,
      requestBody
    );

    return response;
  } catch (error) {
    console.log(error.message);
  } finally {
    dispatch(hideLoader());
  }
};

export const updateWebMenu =
  (requestBody, id) => async (dispatch, getState) => {
    dispatch(showLoader());
    try {
      let URL = ApiConstants.WebMenuURL + "/" + id;
      const method = "POST";
      const response = await fetchServices(
        URL,
        method,
        requestBody
      );

      return response;
    } catch (error) {
      console.log(error.message);
    } finally {
      dispatch(hideLoader());
    }
  };

export const deleteWebMenu =
  (requestBody, deleteId) => async (dispatch, getState) => {
    dispatch(showLoader());
    try {
      let URL = ApiConstants.WebMenuURL + "/" + deleteId;
      const method = "DELETE";
      const response = await fetchServices(
        URL,
        method,
        requestBody
      );

      return response;
    } catch (error) {
      console.log(error.message);
    } finally {
      dispatch(hideLoader());
    }
  };

export const getViewWebMenu = (id) => async (dispatch, getState) => {
  dispatch(showLoader());
  try {
    let URL = ApiConstants.WebMenuURL + "/view/" + id;
    const method = "GET";
    const response = await fetchServices(URL, method, {});
    
    if (response.status_code === 200) {
      dispatch(setViewWebMenuData(response.data));
    }
    return response;
  } catch (error) {
    console.log(error.message);
  } finally {
    dispatch(hideLoader());
  }
};